export interface NewsFilter {
  readonly key: "author" | "tag";
  readonly value: {
    readonly raw: string,
    readonly display: string,
  };
}

export function isEqualNewsFilter(lhs: NewsFilter, rhs: NewsFilter): boolean {
  return lhs.key === rhs.key && lhs.value.raw === rhs.value.raw;
}
